import {configureAnalyticsFromSettings} from '@app/analytics/configure-analytics';
import {getAnalytics} from '@app/analytics/analytics';
import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';
import {useSettings} from '@common/core/settings/use-settings';
import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

export function SpaPageviewTracker() {
  const {analytics} = useSettings();
  const location = useLocation();
  const initial = useRef(true);
  const renderedSsr = getBootstrapData().rendered_ssr === true;

  useEffect(() => {
    configureAnalyticsFromSettings(analytics);
  }, [analytics]);

  useEffect(() => {
    configureAnalyticsFromSettings(analytics);

    const pagePath =
      location.pathname + location.search + (location.hash || '');
    const pageLocation = window.location.href;

    const track = () =>
      getAnalytics().page({
        pagePath,
        pageLocation,
        referrer: document.referrer,
        title: document.title,
      });

    if (initial.current) {
      initial.current = false;
      // With Metrika ssr:true the first hit must be sent after client hydration.
      if (renderedSsr) {
        track();
      }
      return;
    }

    track();
  }, [
    analytics,
    location.pathname,
    location.search,
    location.hash,
    renderedSsr,
  ]);

  return null;
}
